import React, {useState, useRef, useEffect} from 'react';
import {View, Image, Animated, Easing} from 'react-native';

export const RefreshDashBoardView = ({width, height}) => {
   const rotationValue = useRef(new Animated.Value(0)).current;

   const startRotation = () => {
      Animated.loop(
         Animated.timing(rotationValue, {
            toValue: 1,
            duration: 1000,
            easing: Easing.linear,
            useNativeDriver: false,
         }),
      ).start();
   };

   useEffect(() => {
      startRotation();
   }, []);

   const rotate = rotationValue.interpolate({
      inputRange: [0, 1],
      outputRange: ['0deg', '-360deg'],
   });

   return (
      <Animated.Image
         source={require('../assets/refresh_dashboard2.png')}
         style={{
            width: width,
            height: height,
            transform: [{rotate}],
         }}
      />
   );
};

export default RefreshDashBoardView;
